import * as React from 'react';

import styled from 'styled-components';

import CustomBoxHeaderCtrl from '../custom-box-header';
import CollapsableBox from '@webapp/controllers/collapsable-box';

interface SubscriptionBoxCtrlProps {
  className?: string;
  children: React.ReactNode;
  title: React.ReactNode;
  avatar?: string;
  boxText: React.ReactNode;
  isExpiring?: boolean;
  opened?: boolean;
  whiteBg?: boolean;
  hasDarkButton?: boolean;
}

export const SubscriptionBoxCtrl: React.FC<SubscriptionBoxCtrlProps> = (
  props
) => {
  return (
    <StyledBox
      className={`${props.className || ''} mb-10`}
      whiteBg={props.whiteBg}
      hasDarkButton={props.hasDarkButton}
      customHeader={
        <CustomBoxHeaderCtrl
          avatar={props.avatar}
          title={props.title}
          text={props.boxText}
          isExpiring={props.isExpiring ? props.isExpiring : false}
        />
      }
      isOpened={props.opened}
    >
      {props.children}
    </StyledBox>
  );
};

export default styled(SubscriptionBoxCtrl)`
  &:last-child {
    margin-bottom: 0;
  }
`;

const StyledBox = styled(CollapsableBox)``;
